import React from 'react';
import { HelpTooltip } from './HelpTooltip';
import { wt } from './widgetTokens';

interface SliderWidgetProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  description?: string;
  min: number;
  max: number;
  step?: number;
  helpText?: string;
}

export const SliderWidget: React.FC<SliderWidgetProps> = ({
  label,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  description,
  min,
  max,
  step = 1,
  helpText
}) => {
  return (
    <div className={wt.container}>
      <div className={wt.sliderMeta}>
        <div className={wt.labelRow}>
          <label className={wt.label}>
            {label}
            {required && <span className={wt.required}>*</span>}
          </label>
          {helpText && <HelpTooltip helpText={helpText} />}
        </div>
        <span className={wt.sliderValue}>{value}</span>
      </div>
      {description && <p className={wt.description}>{description}</p>}
      <input
        type="range"
        value={value ?? min}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        aria-label={label}
        className={wt.sliderTrack}
      />
      <div className={wt.sliderMeta}>
        <span className={wt.sliderMinMax}>{min}</span>
        <span className={wt.sliderMinMax}>{max}</span>
      </div>
      {error && <p className={wt.errorMsg}>{error}</p>}
    </div>
  );
};

export default SliderWidget;
